module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book-root"
  }, [_c('div', {
    staticClass: "pages-container"
  }, [_c('div', {
    staticClass: "page",
    style: ({
      transform: 'rotateY(0deg)'
    })
  }, [_c('div', {
    staticClass: "front"
  }, [_vm._t("page1", [_vm._v("\n          首页\n        ")])], 2)]), _vm._v(" "), _vm._l((_vm.pageCount), function(n) {
    return _c('div', {
      staticClass: "page",
      style: (_vm.getPageStyle(n))
    }, [_c('div', {
      staticClass: "front"
    }, [_vm._t(("page" + (n * 2 + 1)), [_vm._v("\n          页码" + _vm._s(n * 2) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "control",
      on: {
        "click": function($event) {
          _vm.currentShowPageCount--
        }
      }
    }, [_c('span', [_vm._v("prev")])])], 2), _vm._v(" "), _c('div', {
      staticClass: "back"
    }, [_vm._t(("page" + (n * 2)), [_vm._v("\n          页码" + _vm._s(n * 2 - 1) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "control",
      on: {
        "click": function($event) {
          _vm.currentShowPageCount++
        }
      }
    }, [_c('span', [_vm._v("next")])])], 2)])
  }), _vm._v(" "), _c('div', {
    staticClass: "page",
    style: ({
      transform: 'rotateY(180deg)'
    })
  }, [_c('div', {
    staticClass: "back"
  }, [_vm._t(("page" + _vm.pageSlotCount), [_vm._v("\n          尾页\n        ")])], 2)])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74440c44"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/book/book.vue
// module id = 194
// module chunks = 0